import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { ja } from './ja';
import { tr } from './tr';
export const localeMessages = {
    en,
    tr,
    es,
    fr,
    de,
    ja,
};
export { en };
